var React = require('react');

function Scrubber (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M248,8C111,8,0,119,0,256S111,504,248,504,496,393,496,256,385,8,248,8Zm0,312a64,64,0,1,1,64-64A64,64,0,0,1,248,320Z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M248,320a64,64,0,1,1,64-64A64,64,0,0,1,248,320Z","className":"fa-primary","key":2})]);
}

Scrubber.defaultProps = {"viewBox":"0 0 496 512","className":"icon"};

module.exports = Scrubber;

Scrubber.default = Scrubber;
